import type { FaireProductEntity } from "../../entity_types/product";

export const p_cuh9zfbh6q: FaireProductEntity = {
  token: "p_cuh9zfbh6q",
  type: "product",
  name: "Knitted cardigan with a color-blocking strap",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2c85b87ec857bf7773301e5eb0a54716d243824b8e432ab8cab14c6f80488231.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f38596dc10d30ddb30a8bf4aabe8cc3551d2bbca3e6395594c4c8c5a71f4b0bc.jpeg",
    "https://cdn.faire.com/fastly/970e9f1f6862de53a538b96953c91953ca758b441ef3df500e9ccf3ec928050e.jpeg",
    "https://cdn.faire.com/fastly/313200cd4d32b9035d6fa1a45b7dd3a757f30a0d2abc0411de32546f686e0019.jpeg",
    "https://cdn.faire.com/fastly/f284d79d25300f99d7778f3f92d583139b66ac397995709676c3b1550331a31c.jpeg",
    "https://cdn.faire.com/fastly/96daeb0a1db9c59ad79b72387e3eb668b8fd8c2c4858b5449fcfe41c6d8ab4d9.jpeg",
    "https://cdn.faire.com/fastly/99e3c9eac0d07d37daa70fb39c06bfdb75208a0f501a75a0e4e191d90f821bf1.jpeg",
    "https://cdn.faire.com/fastly/b1dd3a1192279d31c19336a0bf57edef8834d1f0803be0f8c60cef3c14e32d46.jpeg",
    "https://cdn.faire.com/fastly/a5c81984f038c31479f4d1640ef05a275ab449d1e17d1ebf842816ef727d17b2.jpeg",
    "https://cdn.faire.com/fastly/ef2db3b84b280947409728f8804710470b5390e54e3bc839fa5defa5199a23f7.jpeg",
    "https://cdn.faire.com/fastly/31fa7f0752282b9b72cb858b5771fb7854e5a2623689cbe6e9a7dfc5d8edd7a0.jpeg",
    "https://cdn.faire.com/fastly/5101447054a78d9e3907ecb9a7e1e226ef5dec3dffa6f95d2a70d7d25fef670e.jpeg",
  ],
  priceDollars: 27.16,
  description:
    "Knitted cardigan with a color-blocking strap\n65% ACRYLIC, 35% POLYAMIDE\nSIZES : S,M,L\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，       crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 54.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:22.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
